import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SoundProvider } from "@/context/SoundContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StoreSelect from "@/pages/StoreSelect";
import Kiosk from "@/pages/Kiosk";
import Warehouse from "@/pages/Warehouse";
import FrontDesk from "@/pages/FrontDesk";
import Supervisor from "@/pages/Supervisor";
import Coaching from "@/pages/Coaching";
import CompanyDashboard from "@/pages/admin/CompanyDashboard";
import Locations from "@/pages/admin/Locations";
import Employees from "@/pages/admin/Employees";
import Settings from "@/pages/admin/Settings";
import Reports from "@/pages/admin/Reports";
import Checkin from "@/pages/Checkin";
import StatusBoard from "@/pages/StatusBoard";
import Platform from "@/pages/Platform";
import Pricing from "@/pages/Pricing";

const HOME = { warehouse_agent: "/warehouse", front_desk_agent: "/frontdesk", supervisor: "/supervisor", company_admin: "/admin", platform_admin: "/platform" };

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={HOME[user.role] || "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SoundProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/kiosk/:companyCode/:storeCode" element={<Kiosk />} />
              <Route path="/select-store" element={<ProtectedRoute><StoreSelect /></ProtectedRoute>} />
              <Route path="/warehouse" element={<ProtectedRoute roles={["warehouse_agent","supervisor","company_admin"]}><Warehouse /></ProtectedRoute>} />
              <Route path="/frontdesk" element={<ProtectedRoute roles={["front_desk_agent","supervisor","company_admin"]}><FrontDesk /></ProtectedRoute>} />
              <Route path="/checkin" element={<ProtectedRoute roles={["front_desk_agent","supervisor","company_admin"]}><Checkin /></ProtectedRoute>} />
              <Route path="/status" element={<ProtectedRoute roles={["warehouse_agent","front_desk_agent","supervisor","company_admin","platform_admin"]}><StatusBoard /></ProtectedRoute>} />
              <Route path="/supervisor" element={<ProtectedRoute roles={["supervisor","company_admin","platform_admin"]}><Supervisor /></ProtectedRoute>} />
              <Route path="/coaching" element={<ProtectedRoute><Coaching /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["company_admin","platform_admin"]}><CompanyDashboard /></ProtectedRoute>} />
              <Route path="/admin/locations" element={<ProtectedRoute roles={["company_admin","platform_admin"]}><Locations /></ProtectedRoute>} />
              <Route path="/admin/employees" element={<ProtectedRoute roles={["company_admin","platform_admin"]}><Employees /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute roles={["company_admin","platform_admin"]}><Settings /></ProtectedRoute>} />
              <Route path="/admin/reports" element={<ProtectedRoute roles={["supervisor","company_admin","platform_admin"]}><Reports /></ProtectedRoute>} />
              <Route path="/platform" element={<ProtectedRoute roles={["platform_admin"]}><Platform /></ProtectedRoute>} />
              <Route path="/" element={<RootRedirect />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
        </SoundProvider>
      </AuthProvider>
    </div>
  );
}

export default App;


